import Bank from "../assets/images/icons/bank.svg";
import CashPickup from "../assets/images/icons/cash-pickup.svg";
import CoinSwap from "../assets/images/icons/coin-swap.svg";
import CardToCard from "../assets/images/icons/card-to-card.svg";
import MobileWallet from "../assets/images/icons/mobile-wallet.svg";
import CreditCardUpload from "../assets/images/icons/credit-card-upload.svg";
import i18n from "../i18n/config";
import { ROUTES } from "./clientRoutes";
import { CARD_DIRECTIVE_TYPES, RR_RSP, RR_TRANSFER_METHODS, SEND_MONEY_TRANSFER_METHOD_IDS } from "./enums";
import { FEATURE_FLAGS } from "./featureFlags";
import { EVENTS } from "./events";

export const MOBILE_WALLET_LINK_ID = "mobile-wallet";

export const MY_CARD_MISC_LINKS = [
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.RECENT_TRANSACTIONS"),
    link: ROUTES.MY_CARD.RECENT_TRANSACTIONS,
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.CANCEL_ON_DEMAND_TRANSFER"),
    link: ROUTES.ODT.TRANSFERS,
    featureFlag: FEATURE_FLAGS.CANCEL_ON_DEMAND_TRANSFER
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.MONTHLY_STATEMENTS"),
    link: ROUTES.MY_CARD.CARD_STATEMENTS
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.WAGE_STATEMENTS"),
    link: ROUTES.WAGE_STATEMENTS,
    featureFlag: FEATURE_FLAGS.WAGE_STATEMENTS
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.REQUEST_COMPANION_CARD"),
    link: ROUTES.MY_CARD.REQUEST_COMPANION_CARD,
    featureFlag: FEATURE_FLAGS.COMPANION_CARD
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.CARD_CURRENCY_CONVERTER"),
    link: ROUTES.CURRENCY_CONVERTER,
    featureFlag: FEATURE_FLAGS.DISPLAY_CURRENCY_CONVERTER
  },
];

export const MY_CARD_TRANSFER_LINKS = [
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.TO_BANK_ACCOUNT"),
    subtitle: i18n.t("PAGES.MY_CARD.INDEX.LINK_SUBTITLES.TO_BANK_ACCOUNT"),
    icon: Bank
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.SEND_ON_DEMAND"),
    subtitle: i18n.t("PAGES.MY_CARD.INDEX.LINK_SUBTITLES.SEND_ON_DEMAND"),
    link: ROUTES.ODT.BANK_ACCOUNT_SELECTION,
    featureFlag: FEATURE_FLAGS.SEND_TO_BANK_ACCOUNT
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.SEND_WITH_BRIGHTWELL"),
    subtitle: i18n.t("PAGES.MY_CARD.INDEX.LINK_SUBTITLES.SEND_WITH_BRIGHTWELL"),
    link: ROUTES.RR_SDK.SENDER_DETAILS(RR_RSP.MASTERCARD, RR_TRANSFER_METHODS.SEND_WITH_BRIGHTWELL),
    featureFlag: FEATURE_FLAGS.MC_TO_ACCOUNT,
    getRRAuth: true,
    rsp: RR_RSP.MASTERCARD,
    transferMethod: RR_TRANSFER_METHODS.SEND_WITH_BRIGHTWELL,
    event: {
      name: EVENTS.READY_REMIT.MC_TO_ACCOUNT.SEND_WITH_BRIGHTWELL
    }
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.SEND_WITH_WESTERN_UNION"),
    subtitle: i18n.t("PAGES.MY_CARD.INDEX.LINK_SUBTITLES.SEND_WITH_WESTERN_UNION"),
    link: ROUTES.WU_TO_ACCOUNT.INDEX,
    featureFlag: FEATURE_FLAGS.WESTERN_UNION_TO_ACCOUNT_ENABLED,
    event: {
      name: EVENTS.TO_ACCOUNT.STARTED
    }
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.SEND_WITH_WESTERN_UNION"),
    subtitle: i18n.t("PAGES.MY_CARD.INDEX.LINK_SUBTITLES.SEND_WITH_WESTERN_UNION"),
    link: ROUTES.MY_CARD.WESTERN_UNION,
    featureFlag: FEATURE_FLAGS.WESTERN_UNION
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.CASH_PICKUP"),
    subtitle: i18n.t("PAGES.MY_CARD.INDEX.LINK_SUBTITLES.CASH_PICKUP"),
    link: ROUTES.MONEY_TRANSFER,
    icon: CashPickup,
    featureFlag: FEATURE_FLAGS.DISPLAY_CASH_PICKUP
  },
  {
    id: MOBILE_WALLET_LINK_ID,
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.MOBILE_WALLET"),
    subtitle: i18n.t("PAGES.MY_CARD.INDEX.LINK_SUBTITLES.MOBILE_WALLET"),
    icon: MobileWallet,
    featureFlag: FEATURE_FLAGS.MC_MOBILE_WALLET,
    event: {
      name: EVENTS.READY_REMIT.MOBILE_WALLET.SEND_TO_MOBILE_WALLET
    },
    modal: {
      title: i18n.t("PAGES.MY_CARD.INDEX.CARD_DIRECTIVE_MODAL.MOBILE_WALLET.TITLE"),
      body: i18n.t("PAGES.MY_CARD.INDEX.CARD_DIRECTIVE_MODAL.MOBILE_WALLET.BODY"),
      primaryAction: {
        id: "mobile-wallet-continue",
        text: i18n.t("COMMON.CONTINUE"),
        directiveType: CARD_DIRECTIVE_TYPES.MOBILE_WALLET_CONTINUE
      },
      secondaryAction: {
        id: "mobile-wallet-go-back",
        text: i18n.t("COMMON.GO_BACK"),
        directiveType: CARD_DIRECTIVE_TYPES.CLOSE_MODAL
      }
    }
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.PUSH_TO_CARD"),
    subtitle: i18n.t("PAGES.MY_CARD.INDEX.LINK_SUBTITLES.PUSH_TO_CARD"),
    icon: CreditCardUpload,
    featureFlag: FEATURE_FLAGS.PUSH_TO_CARD_ENABLED,
    event: {
      name: EVENTS.READY_REMIT.PUSH_TO_CARD.SDK_SELECTED
    },
    modal: {
      title: i18n.t("PAGES.MY_CARD.INDEX.CARD_DIRECTIVE_MODAL.PUSH_TO_CARD.TITLE"),
      body: i18n.t("PAGES.MY_CARD.INDEX.CARD_DIRECTIVE_MODAL.PUSH_TO_CARD.BODY"),
      primaryAction: {
        id: "push-to-card-continue",
        text: i18n.t("COMMON.CONTINUE"),
        directiveType: CARD_DIRECTIVE_TYPES.PUSH_TO_CARD_CONTINUE
      },
      secondaryAction: {
        id: "push-to-card-go-back",
        text: i18n.t("COMMON.GO_BACK"),
        directiveType: CARD_DIRECTIVE_TYPES.PUSH_TO_CARD_CLOSE_MODAL
      }
    }
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.DIRECT_PAY"),
    subtitle: i18n.t("PAGES.MY_CARD.INDEX.LINK_SUBTITLES.DIRECT_PAY"),
    icon: CoinSwap,
    link: ROUTES.ALLOCATIONS.INDEX,
  },
  {
    title: i18n.t("PAGES.MY_CARD.INDEX.LINK_TITLES.CARD_TO_CARD"),
    subtitle: i18n.t("PAGES.MY_CARD.INDEX.LINK_SUBTITLES.CARD_TO_CARD"),
    icon: CardToCard,
    link: ROUTES.MY_CARD.CARD_TO_CARD_TRANSFER,
    featureFlag: FEATURE_FLAGS.ALLOW_CARD_TO_CARD_TRANSFER
  }
];